/**
 * Shared Constants
 * Centralized location for all application-wide constants
 */

export const CURRENCIES = {
  USD: { symbol: '$', name: 'USD' },
  EUR: { symbol: '€', name: 'EUR' },
  GEL: { symbol: '₾', name: 'GEL' }
};

export const DEFAULT_EXCHANGE_RATES = {
  USD: 1,
  EUR: 0.92,
  GEL: 2.7
};

export const COLORS = {
  PRIMARY: '#de4010',
  GRAY_TEXT: '#333',
  GRAY_LIGHT: '#999',
  GRAY_BORDER: '#ddd',
  ERROR_BG: '#f8d7da',
  ERROR_TEXT: '#721c24',
  SUCCESS_BG: '#d4edda',
  SUCCESS_TEXT: '#155724'
};

export const BREAKPOINTS = {
  MOBILE: '480px',
  TABLET: '768px',
  DESKTOP: '1024px'
};
